import { Component, OnInit } from '@angular/core';

import { AllAvailableFeatureFlags, AllAvailableFeatureFlagsName } from '../configs/all-flags.config';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-feature-flag-debug-mode',
	templateUrl: './feature-flag-debug-mode.component.html',
	styleUrls: ['./feature-flag-debug-mode.component.scss']
})
export class FeatureFlagDebugModeComponent implements OnInit {
	public allFlags: string[];
	public flagsName = AllAvailableFeatureFlagsName;
	public selectedFlags: string[] = [];
	public isMinimized: boolean = false;

	constructor() {
		this.allFlags = Object.values(AllAvailableFeatureFlags);
	}

	public ngOnInit(): void {
		this.allFlags.forEach(flag => {
			if (localStorage.getItem(flag)) {
				this.selectedFlags.push(flag);
			}
		});
	}

	public applyFeatureFlag(): void {
		this.allFlags.forEach(flag => {
			localStorage.removeItem(flag);
		});

		this.selectedFlags.forEach(flag => {
			localStorage.setItem(flag, 'enabled');
		});
		location.reload();
	}

	public resetFeatureFlag(): void {
		this.allFlags.forEach(flag => {
			localStorage.removeItem(flag);
		});
		location.reload();
	}

	public onToggleFlag(flag: string): void {
		if (!this.selectedFlags.includes(flag)) {
			this.selectedFlags.push(flag);
		} else {
			const itemToRemove = this.selectedFlags.findIndex(flagInList => flagInList === flag);
			this.selectedFlags.splice(itemToRemove, 1);
		}
	}
}
